<template>
    <svg height="22px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185 32.8">
        <path class="st0" d="M154.4.6h-25.8c-1.7 0-3.1 1.3-3.2 2.9-.1 1.6 1.2 3.1 3 3.1h26.1v-6z" />
        <path class="st1" d="M154.4 13.4h-25.8c-1.7 0-3.1 1.3-3.2 2.9-.1 1.6 1.2 3.1 2.9 3.1h26.2v-6z" />
        <path class="st2" d="M154.4 26.2h-25.8c-1.7 0-3.1 1.3-3.2 2.9-.1 1.6 1.2 3.1 3 3.1h26.1v-6z" />
        <path class="st3"
            d="M19 21h6.9v1.6c0 1-.2 1.9-.4 2.8-.3 1-.8 1.9-1.4 2.8-.6 1-1.4 1.8-2.4 2.4-1.1.7-2.4 1.3-3.6 1.6-1.7.4-3.4.7-5.1.6-2.1 0-4.3-.3-6.2-1-1.6-.5-3-1.5-4-2.8-.9-1.1-1.6-2.3-2.1-3.7C.2 24 0 22.6 0 21.1v-9.5c0-1.4.2-2.8.7-4.2s1.1-2.6 2.1-3.7C3.9 2.4 5.3 1.5 6.9.9c2-.7 4.1-1 6.2-1 2.1-.1 4.2.2 6.2.9 1.5.4 2.9 1.3 4 2.4.9.9 1.6 2 2.1 3.2.5 1.1.7 2.4.6 3.6v1.3h-7v-.9c0-1.2-.5-2.4-1.4-3.1C16.7 6.5 15.2 6 13 6c-2.1 0-3.7.5-4.6 1.6-.9 1.1-1.4 2.5-1.4 4v9.5c-.1 1.4.4 2.8 1.3 4 .9 1 2.5 1.6 4.6 1.6 2.1 0 3.6-.4 4.6-1.3.9-.8 1.4-2 1.4-3.2V21zm31.8 11.3l-2.2-6.4H36.9l-2.1 6.4h-7.1L38.9.5h7.8L58 32.2h-7.2zm-4.1-11.9l-4-11.8-3.9 11.8h7.9zm28.1 1.1h-6.2v10.7h-7V.5h12.6c2.2-.1 4.3.2 6.5.8 1.6.4 3 1.3 4.2 2.4.9 1 1.7 2.1 2.1 3.3.5 1.3.7 2.6.7 3.9 0 4.6-2.1 7.6-6.1 9.3l5.5 11.9h-7.4l-4.9-10.6zm-.6-15.2h-5.7v9.6h5.7c4.2 0 6.3-1.6 6.3-4.8 0-3.3-2.1-4.7-6.3-4.8zm39.7 26L99.9 13v19.3h-6.6V.5h5.9L113 19.8V.5h6.6v31.7h-5.7zM185 6.6h-9.5v25.7h-7V6.6h-9.4v-6H185v6z" />
    </svg>
</template>
<script>
export default {
    name: "carnet"
}
</script>
<style lang="scss">
.st0 {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.3);
}

.st1 {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.4);
}

.st2 {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.3);
}

.st3 {
    transition: .4s ease;
    fill: rgba(0, 0, 0, 0.2);
}
svg {
    &:hover {
        .st0 {
            transition: .4s ease;
            fill: #00ae4d!important;
        }

        .st1 {
            transition: .4s ease;
            fill: #ae519f!important;
        }

        .st2 {
            transition: .4s ease;
            fill: #1b75bc!important;
        }

        .st3 {
            transition: .4s ease;
            fill: #6d6e71!important;
        }
    }
}
</style>